import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import { Locale } from "../Locale.js";
import type { LocalizedString } from "../Locale.js";
import { PaymentType } from "../PaymentType.js";

export const paymentTypeNameMap: Record<PaymentType, LocalizedString> = {
	[PaymentType.GoPayPaymentCard]: { [Locale.cs]: "Kartou", [Locale.en]: "Credit card" },
	[PaymentType.OnDelivery]: { [Locale.cs]: "Dobírkou", [Locale.en]: "Cash on delivery" },
	[PaymentType.GoPayGPay]: sameValueForEveryLocale("Google Pay"),
	[PaymentType.GoPayApplePay]: sameValueForEveryLocale("Apple Pay"),
	// [PaymentType.GoPayPayPal]: sameValueForEveryLocale("PayPal"),
	[PaymentType.GoPayQRCode]: { [Locale.cs]: "QR kódem", [Locale.en]: "QR code" },
	[PaymentType.OnInvoice]: { [Locale.cs]: "Na fakturu", [Locale.en]: "On invoice" },
	[PaymentType.WithoutInvoice]: { [Locale.cs]: "Bez faktury", [Locale.en]: "Without invoice" },
};
